import { S3 } from "../../constants";
import BookTourPage from "./BookTourPage";

const TOKEN_PATTERN = /^[0-9a-f]{64}$/;

const BookTour = (app) => {
  app.get("/book/consult/:token", async ({ req, res, locals, load }) => {
    const token = String(req.params.token ?? "");
    const { config, error } = TOKEN_PATTERN.test(token)
      ? ((await load("tourConfig", { token })) ?? {
          config: null,
          error: "unavailable",
        })
      : { config: null, error: "invalid-token" };

    const embed = String(req.query?.embed ?? "") === "1";

    locals.tourToken = token;
    locals.tourConfig = config;
    locals.tourError = error;
    locals.tourEmbed = embed;

    locals.title =
      config && !embed
        ? `${config.name} — ${config.gym?.name ?? "MyStrengthBook"}`
        : "Book a consult";
    locals.description = (!embed && config?.description) || "Book a consult.";

    const favicon = config?.branding?.favicon_s3_path;

    if (favicon && !embed) locals.favicon = `${S3.PATH}${favicon}`;

    res.set("Content-Security-Policy", "frame-ancestors *");
    res.remove?.("X-Frame-Options");

    if (!config) res.status = error === "unavailable" ? 503 : 410;

    res.body = <BookTourPage />;
  });
};

export default BookTour;
